export default __webpack_public_path__ + "navigation-examples-embedded-navigation-thumbnail-v1-960-ffdb8686fb4d04275d77eb5d8ddef4a5.webp";